import React from 'react';
import pt from 'prop-types';
import Container from '/src/modules/container';
import SearchField from './components/searchField';
import Tag from '../tag';
import * as styles from './styles.module.scss';

import { getAPIRoot } from '../../../helpers/fetch';
import { combine } from '../../../helpers/styles';
import { API_ROUTES } from '../../../utils/constants';

const Search = ({
  initSearchTerm,
  resetSearchTerm,
  placeholder,
  chips,
  onSubmit,
  onTagClick,
  onInspire,
  type,
  inContentPage,
  className,
}) => {
  const submitSearch = async (queryParams) => {
    let apiRoot = await getAPIRoot();

    if (queryParams === `?find=Inspire Me`) {
      onInspire();
    } else {
      if (/^\?find\=[^&]+$/.test(queryParams)) {
        const term = queryParams.split('=').pop();

        if (term) {
          fetch(`${apiRoot}${API_ROUTES.TRACK_SEARCH}/${term}`);
        }
      }
      onSubmit(queryParams);
    }
  };

  const handleTagClick = (term) => {
    const searchTerm = typeof term === 'string' ? tag : term.label;
    const searchTag = typeof term === 'string' ? tag : term.tag;
    const isInspiration =
      (typeof term === 'string' && term === 'Inspire Me') ||
      (typeof term === 'object' && term.behaviour === 'Inspiration');
    const isQueryParam =
      typeof term === 'object' && term.behaviour === 'Query Parameter';

    if (isInspiration) {
      onInspire();
    } else {
      if (isQueryParam) {
        submitSearch(term.queryParameters);
      } else if (searchTag) {
        onTagClick(searchTag);
      } else {
        submitSearch(`?find=${encodeURIComponent(searchTerm)}`);
      }
    }
  };

  const presetList = chips || [];

  return (
    <Container fluid className={combine(styles.container, className)} noGap>
      <SearchField
        initSearchTerm={initSearchTerm}
        placeholder={placeholder}
        onSubmit={(term) => submitSearch(`?find=${term}`)}
        onReset={resetSearchTerm}
        type={type}
      />
      {!inContentPage && (
        <div className={styles.tags}>
          {presetList.map((item, index) => (
            <Tag key={index} onClick={() => handleTagClick(item)}>
              {typeof item === 'string' ? item : item.label}
            </Tag>
          ))}
        </div>
      )}
    </Container>
  );
};

Search.propTypes = {
  initSearchTerm: pt.string,
  onSubmit: pt.func,
  onTagClick: pt.oneOfType([null, pt.func]),
  onInspire: pt.func,
  resetSearchTerm: pt.func,
  chips: pt.array,
  type: pt.oneOf(['Companies', 'Projects', 'Talent', 'SIP', 'Jury', 'Ranking']),
  inContentPage: pt.bool,
};

Search.defaultProps = {
  initSearchTerm: '',
  onSubmit: () => {},
  onTagClick: null,
  onInspire: () => {},
  resetSearchTerm: () => {},
  chips: [],
  type: 'Companies',
  inContentPage: false,
};

export default Search;
